import { Builder, withChildren } from '@builder.io/react'

import { MainLandmark } from './MainLandmark'

Builder.registerComponent(withChildren(MainLandmark), {
  name: 'MainLandmark',
  canHaveChildren: true,
  noWrap: true,
  hideFromInsertMenu: true,
})
